import { useTracingReportItemsQuery } from '@/features/internal/tracing-report'
import { BodyText } from '@/components/atoms/BodyText'

import { GuidancePrepRow } from '../GuidancePrepRow'

interface Props {
  yakurekiId: string
}

// 確認要点セクションに出すトレーシングレポート検知行 (確認要点行と同じ marker + 主/従 の行構造)。
// NSIPS 受信時のルール検知 (rule 非 null の item) がある場合のみ描画する。表示は検知時に
// 固定化された snapshot 由来で、操作は持たない (登録は portal SOAPルール / 作成は生成後の
// トレーシングレポートタブが担う)。
export const TracingReportPrepRow = ({ yakurekiId }: Props) => {
  const { data } = useTracingReportItemsQuery(yakurekiId)
  const ruleItems = (data ?? []).filter((item) => item.rule !== null)
  if (ruleItems.length === 0) return null

  return (
    <>
      {ruleItems.map((item) => {
        const snapshot = item.snapshot ?? {}
        const names = (snapshot.matched ?? [])
          .map((m) => m.name)
          .filter(Boolean)
          .join('、')
        const prescriber = snapshot.prescriber ?? {}
        const target = [prescriber.institution_name, prescriber.doctor_name]
          .filter(Boolean)
          .join(' ')
        const groupName = snapshot.rule?.drug_group_name ?? ''
        return (
          <GuidancePrepRow
            key={item.id}
            marker="・"
            main={
              <BodyText>
                トレーシングレポート要 —{' '}
                {names ? `${names}の新規処方` : `「${groupName}」該当`}
              </BodyText>
            }
            sub={
              target
                ? `「${groupName}」ルール（${target}との取り決め）`
                : `「${groupName}」ルール該当`
            }
          />
        )
      })}
    </>
  )
}
